require('./resumeTab.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { formatText } = require('core/i18n').i18n;
const moment = require('moment');

// @utilities
const { getUrlDocumentByEncodedId } = require('utilities/pdfDocumentsHelper');
const { buildDataPointForGraph } = require('utilities/buildDataPointForGraph');

//@components
const LineChartGrowth = require('components/d3Components/lineChartETFsGrowth/lineChartETFsGrowth');
const { OKLink } = require('commonsComponents/OKLink');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKButton } = require('components/commons/OKButton/OKButton');

//@constants
const { DATE_PICKER_CUSTOM_LOCALE, DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');

class ResumeTab extends React.Component {

    constructor(props) {
        super(props);
        this.handleRetry = this.handleRetry.bind(this);
    }

    getDateFormat(date) {
        const momentDateLocale = moment(date).locale(DATE_PICKER_CUSTOM_LOCALE);
        const formatedDate = momentDateLocale.format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT));
        return formatedDate.replace('.', '');
    }

    getDocuments(documentsId) {
        let dfiDoc = '',
            biAnnualDoc = '',
            commDoc = '',
            url = '';

        if (documentsId.get('dfiDocId')) {
            url = getUrlDocumentByEncodedId(documentsId.get('dfiDocId'));
            dfiDoc = (
                <OKLink modifier="emphasize" id="lnkBrokerResumeTabLegalDocumentationDFI" to={url}>
                    <span className="broker-product-file-tabs-resume-tab__more-information-text broker-product-file-tabs-resume-tab__more-information-text--documentation">
                        <i className="broker-product-file-tabs-resume-tab__more-information-icon broker-product-file-tabs-resume-tab__more-information-icon--primary icon-documento"></i> {formatText('broker-ratingRiskTabLegalDocumentationDFI')}
                    </span>
                </OKLink>
            );
        }

        if (documentsId.get('biAnnnualReportDoctId')) {
            url = getUrlDocumentByEncodedId(documentsId.get('biAnnnualReportDoctId'));
            biAnnualDoc = (
                <OKLink modifier="emphasize" id="lnkBrokerResumeTabLegalDocumentationSemiAnualReport" to={url}>
                    <span className="broker-product-file-tabs-resume-tab__more-information-text broker-product-file-tabs-resume-tab__more-information-text--documentation">
                        <i className="broker-product-file-tabs-resume-tab__more-information-icon icon-documento"></i> {formatText('broker-ratingRiskTabLegalDocumentationSemiAnualReport')}
                    </span>
                </OKLink>
            );
        }

        if (documentsId.get('commercializationReportDocId')) {
            url = getUrlDocumentByEncodedId(documentsId.get('commercializationReportDocId'));
            commDoc = (
                <OKLink modifier="emphasize" id="lnkBrokerResumeTabLegalDocumentationCommercializationReport" to={url}>
                    <span className="broker-product-file-tabs-resume-tab__more-information-text broker-product-file-tabs-resume-tab__more-information-text--documentation">
                        <i className="broker-product-file-tabs-resume-tab__more-information-icon icon-documento"></i> {formatText('broker-ratingRiskTabLegalDocumentationCommercializationReport')}
                    </span>
                </OKLink>
            );
        }

        return [dfiDoc,
            biAnnualDoc,
            commDoc];
    }

    handleRetry() {
        this.props.retryRequest();
    }

    render() {
        const { etfsProduct } = this.props;

        const administratorCompanyName = etfsProduct.getIn(['administratorCompany', 'name']);
        const inceptionDate = this.getDateFormat(etfsProduct.get('inceptionDate'));
        const netAssetValuesDayEndValue = etfsProduct.getIn(['netAssetValues', 'dayEndValue']);
        const netAssetValuesDayEndDate = this.getDateFormat(etfsProduct.getIn(['netAssetValues', 'dayEndDate']));
        const netAssetValuesDayCurrencyId = etfsProduct.getIn(['netAssetValues', 'currencyId']);
        const customCategoryId = etfsProduct.getIn(['benchmark', 'name'], '-');
        const investmentStrategy = etfsProduct.get('investmentStrategy');

        const chartData = etfsProduct.get("growthOf10K");
        const pointsData = chartData.get('decemberPoints');
        const currencyId = chartData.get('currencyId');
        const pointsForGraph = buildDataPointForGraph(pointsData);

        const CHART_WIDTH = "1100";
        const CHART_HEIGHT = "300";

        let lineChart;

        if (etfsProduct.get('isFetchingETFByIsin')) {
            lineChart = (
                <div style={{ width: CHART_WIDTH + "px", height: CHART_HEIGHT + "px" }}>
                    <LoadingSection />
                </div>
            );
        } else if (etfsProduct.get('fetchingETFByIsinFailed')) {
            const lostConnectionFirstLine = formatText('broker-lostConnectionFirstLine');
            const retryButton = (
                <OKButton
                    id="btn_walletsChart_retry"
                    onClick={this.handleRetry}>
                    {formatText("broker-retry")}
                </OKButton>
            );
            lineChart = (
                <div style={{ width: CHART_WIDTH + "px", height: CHART_HEIGHT + "px" }}>
                    <EmptyState
                        button={retryButton}
                        primaryText={lostConnectionFirstLine}
                        iconType="nointernet-wealth"
                    />
                </div>
            );
        } else if (chartData.size > 0 && pointsForGraph) {
            lineChart = (
                <LineChartGrowth
                    width={CHART_WIDTH}
                    height={CHART_HEIGHT}
                    lineData={pointsForGraph}
                    pointsData={pointsData ? pointsData : null}
                    currencyId={currencyId}
                />
            );
        }

        return (
            <div id="brokerProductFileTabsResumeTab" className="broker-product-file-tabs-resume-tab">
                {pointsForGraph &&
                    <div className="row">
                        <div className="col-xs-12">
                            <h4 className="broker-product-file-tabs-resume-tab__title">{formatText('broker-resumeTabTitle')}</h4>
                        </div>
                    </div>
                }
                {/*
                    Here we are setting the with of the graph to 1140px and
                    wrapping it inside a div with overflow x to create an
                    horizintal scroll.
                */}
                <div style={{ overflowX: 'auto' }}>
                    <div className="row no-outside-gutter" style={{ width: '1140px' }}>
                        <div className="col-xs-12 broker-product-file-tabs-resume-tab__product-resume">
                            {lineChart}
                            {pointsForGraph &&
                                <p className="broker-product-file-tabs-resume-tab__resume-chart-disclaimer">{formatText('broker-ratingRiskTabRiskChartDisclaimerETF')}</p>
                            }
                            <h4 className="broker-product-file-tabs-resume-tab__subtitle">{formatText('broker-ratingRiskTabRiskObjetivesTitle')}</h4>
                            <p className="broker-product-file-tabs-resume-tab__text"> {investmentStrategy} </p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="broker-product-file-tabs-resume-tab__more-information">
                        <div className="col-xs-12">
                            <h4 className="broker-product-file-tabs-resume-tab__more-information-title">{formatText('broker-ratingRiskTabMoreInformation')}</h4>
                        </div>
                        <div className="col-xs-4">
                            <div className="broker-product-file-tabs-resume-tab__more-information-item">
                                <span className="broker-product-file-tabs-resume-tab__more-information-label">{formatText('broker-ratingRiskTabMorningstarCategory')}</span>
                                <span className="broker-product-file-tabs-resume-tab__more-information-text">{customCategoryId}</span>
                            </div>

                            <div className="broker-product-file-tabs-resume-tab__more-information-item">
                                <span className="broker-product-file-tabs-resume-tab__more-information-label">{formatText('broker-ratingRiskTabAdministratorCompany')}</span>
                                <span className="broker-product-file-tabs-resume-tab__more-information-text">{administratorCompanyName}</span>
                            </div>

                            <div className="broker-product-file-tabs-resume-tab__more-information-item">
                                <span className="broker-product-file-tabs-resume-tab__more-information-label">{formatText('broker-ratingRiskTabInceptionDate')}</span>
                                <span className="broker-product-file-tabs-resume-tab__more-information-text broker-product-file-tabs-resume-tab__more-information-date">{inceptionDate}</span>
                            </div>

                            <div className="broker-product-file-tabs-resume-tab__more-information-item">
                                <span className="broker-product-file-tabs-resume-tab__more-information-label">{formatText('broker-ratingRiskTabAssets')}</span>
                                <span className="broker-product-file-tabs-resume-tab__more-information-text">
                                    {netAssetValuesDayCurrencyId} {netAssetValuesDayEndValue} (
                                    <span className="broker-product-file-tabs-resume-tab__more-information-date">{netAssetValuesDayEndDate}</span>)
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ResumeTab.propTypes = {
    etfsProduct: PropTypes.object.isRequired,
    retryRequest: PropTypes.func.isRequired
}

module.exports = ResumeTab;
